import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { isNavigationFailure } from 'vue-router';
import { useRouter } from 'vue-router/composables';
import { showError } from '@/application/common/snackbar/service';
import { useAuthenticationStore } from '@/application/whitelabel/authentication/store';
import { isAndroid, isNativeApplication } from '@/helpers/detection-helpers';
import RequestCompanyAccessDialog from '@/public/contact/components/request-company-access-dialog.vue';
import CreateContactMessageDialog from '@/public/contact/components/create-contact-message-dialog.vue';
import { constructForm, Form, FormControl, FormControls, getFormValues } from '@/components/form';
import { AppType } from '@/types';
import { LoginAction } from '../types';

interface Controls extends FormControls {
  emailAddress: FormControl<string>;
  password: FormControl<string>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const authenticationStore = useAuthenticationStore();
const router = useRouter();

const form = ref<Form<Controls> | null>(null);

const isSubmitDisabled = computed<boolean>(() => !form.value || !form.value.isValid);

const isCompanyRegistrationVisible = computed<boolean>(() => authenticationStore.appType === AppType.SPONSOR
  && (
    !isNativeApplication()
    || isAndroid()
  ));

const isGeneralContactVisible = computed<boolean>(() => authenticationStore.appType === AppType.COURSE);

const isTechnicalContactVisible = computed<boolean>(() => authenticationStore.appType === AppType.SPONSOR
  && (
    !isNativeApplication()
    || isAndroid()
  ));

const areStoreLinksVisible = computed<boolean>(() => !isNativeApplication()
  && (
    !!authenticationStore.appStoreLink
    || !!authenticationStore.playStoreLink
  ));

const isAppStoreLinkVisible = computed<boolean>(() => !isNativeApplication()
  && !!authenticationStore.appStoreLink);

const isPlayStoreLinkVisible = computed<boolean>(() => !isNativeApplication()
  && !!authenticationStore.playStoreLink);

onMounted(() => {
  form.value = buildForm();

  if (authenticationStore.isAuthenticated) {
    router.push({ name: 'default' });
  }
});

function buildForm(): Form<Controls> {
  return constructForm({
    submitted,
    controls: {
      emailAddress: {
        label: 'E-Mail Adresse',
        value: null,
        isRequired: true,
      },
      password: {
        label: 'Passwort',
        value: null,
        isRequired: true,
      },
    },
  });
}

function submitted(): void {
  const formValues = getFormValues(form.value!);

  const command: LoginAction = {
    emailAddress: formValues.emailAddress!,
    password: formValues.password!,
  };

  authenticationStore.login(command)
    .then(() => router.push({ name: 'default' }))
    .catch((error) => {
      if (isNavigationFailure(error)) {
        return;
      }

      // Don't show a message for disabled user as this is already done by the authentication interceptor
      if (error.response?.data.identifier !== 'user-disabled') {
        const message = error.response?.data.message || 'Die Anmeldung ist fehlgeschlagen';
        showError({ message });
      }
    });
}

return { __sfc: true,authenticationStore, router, form, isSubmitDisabled, isCompanyRegistrationVisible, isGeneralContactVisible, isTechnicalContactVisible, areStoreLinksVisible, isAppStoreLinkVisible, isPlayStoreLinkVisible, buildForm, submitted, RequestCompanyAccessDialog, CreateContactMessageDialog }
}

})